module.exports = __webpack_public_path__ + "img/autospin_btn.1a82fec5.png";